import { CoreIcon } from '../core-icon';
import lockSVG from '../../assets/icons/lock.svg';
import type { IconProps } from '../core-icon';

export const LockIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={lockSVG} {...props} />;
};
